module.exports = __webpack_public_path__ + "static/media/52 - Chemise - She Can't Love You.8dfeeed5.mp3";